<template>
	<div style="margin-bottom:100px;">
		<TableView
			registerName="Inserir Laboratório"
			:onRegister="(this.validarPermissao(570) ? onRegister: null)"
			:onEdit="onEdit"
			:onDelete="onDelete"
			:onSearch="getLaboratorio"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="loadingTable"
			:loadingEditAll="loadingEditAll"
			:pagination="pagination"
			:response="response"
		>
		</TableView>
	</div>
</template>

<script>

	import TableView from 'common/table'
	import Rest from 'common/rest'
	import Fct from 'common/fct'

  	export default {
  		name:"empresa",
  		components: {TableView},
  		mixins:[Rest],
  		data () {
		   	return {
		   		formData:{
		   			id:0,
		   			nome:null,
		   			cbo:null,
		   			descricao:null,
		   		},
				pagination:{},
				response:{},
		   		tableHead:[
					{
		                key: 'id',
						sortable: true,
						width:'60px',
						label: 'Cód',
		            },
		   			{
		                key: 'cnpj',
						sortable: true,
						width:'150px',
						label: 'CNPJ',
		            },
		            {
		                key: 'nome',
						sortable: true,
						label: 'Nome',
					},
					{
		                key: 'telefone',
						sortable: true,
						label: 'Telefone',
					},
					{
		                key: 'responsavel',
						sortable: true,
						label: 'Responsável',
					},
					{
		                key: 'email',
						sortable: true,
						label: 'Email',
					},
		   		],
		   		tableData:[],
		   		loadingTable:true,
		   		loadingEditAll:false,
		   		showFormEdit:false,
		   		showFormVinculo:false,
		   		lstTipoPagamento:[]

			}
		},

		created(){
		},

		mounted: function() {
			this.getLaboratorio();
		},

		methods: {

			onRegister: function(){
				this.$router.push({name:'ltcat.laboratorio.cadastrar'});
			},

			onEdit: function(data){
				this.$router.push({name:'ltcat.laboratorio.editar',params: {id:data.id}});
			},

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    type: 'warning'

                }).then(() => {

                    self.loadingEditAll = true;

                    this.post('/laboratorio/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.loadingEditAll = false;

                        if(result.status == 200){
                            self.getLaboratorio();
                            self.edMsg('Registo excluido com sucesso');
                        }
                    });

                });
			},

			getLaboratorio: function(_search,_page,_pagination,_loading){

				this.loadingTable = true;
				this.response = {};

				this.get('laboratorio',{search:_search,page:_page,pagination:_pagination}).then((result)=>{

					result = result[0];
					this.response = result;
					this.loadingTable = false;

		            if(result.status == 200){

		             	var
		             		data = result.data.data,
		             		tableData = [],
		             		self = this,
		             		pagination = result.data

		             	for (var i = 0; i < data.length; i++) {

		             		var item = {
								'id': data[i].id,
		             			'cnpj': data[i].cnpj,
								'nome': data[i].nome,
								'telefone': data[i].tel_com,
								'email': data[i].email,
								'responsavel': data[i].resp,
		             			_data:data[i],
		             			options:{
									disable_delete:!this.validarPermissao(570),
									disable_edit:!this.validarPermissao(570),
								},
		             			buttons:[]
		             		};

		             		tableData.push(item);
		            	}

		             	this.pagination = pagination;
		             	this.tableData = tableData;
		             }
	            });
			},

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?589a892e